import moment from "moment";
import { PARTNER_STATISTICS_GROUP_TYPE } from "./statisticsConstants.js";

export const getCurrentDate = () => moment();

export const DATE_PRESETS_CONFIG = [
    {
        name: 'today',
        title: 'statistics.presets.today',
        startDate: () => moment(),
        endDate: getCurrentDate,
    },
    {
        name: 'yesterday',
        title: 'statistics.presets.yesterday',
        startDate: () => moment().subtract(1, 'days'),
        endDate: () => moment().subtract(1, 'days'),
    },
    {
        name: 'lastSevenDays',
        title: 'statistics.presets.last_seven_days',
        startDate: () => moment().subtract(7, 'days'),
        endDate: getCurrentDate,
    },
    {
        name: 'lastThirtyDays',
        title: 'statistics.presets.last_thirty_days',
        startDate: () => moment().subtract(30, 'days'),
        endDate: getCurrentDate,
    },
    {
        name: 'currentMonth',
        title: 'statistics.presets.current_month',
        startDate: () => moment().startOf('month'),
        endDate: getCurrentDate,
    },
    {
        name: 'previousMonth',
        title: 'statistics.presets.previous_month',
        startDate: () => moment().subtract(1, 'month').startOf('month'),
        endDate: () => moment().subtract(1, 'month').endOf('month'),
    },
    {
        name: 'allTime',
        title: 'statistics.presets.all_time',
        startDate: () => null,
        endDate: () => null,
    },
];

export const GROUP_CONFIG = {
    [PARTNER_STATISTICS_GROUP_TYPE.CAMPAIGN]: {
        field: 'campaign_name',
        format: value => value,
        title: 'statistics.groups.campaign',
        type: PARTNER_STATISTICS_GROUP_TYPE.CAMPAIGN,
        order: 4,
    },
    [PARTNER_STATISTICS_GROUP_TYPE.CHANNEL]: {
        field: 'campaign_channel',
        format: value => value,
        title: 'statistics.groups.channel',
        type: PARTNER_STATISTICS_GROUP_TYPE.CHANNEL,
        order: 5,
    },
    [PARTNER_STATISTICS_GROUP_TYPE.DAY]: {
        field: 'date',
        format: value => moment(value).format('DD/MM/YYYY'),
        title: 'statistics.groups.day',
        type: PARTNER_STATISTICS_GROUP_TYPE.DAY,
        order: 1,
    },
    [PARTNER_STATISTICS_GROUP_TYPE.WEEK]: {
        field: 'date',
        format: value => moment(value).format('WW/YYYY'),
        title: 'statistics.groups.week',
        type: PARTNER_STATISTICS_GROUP_TYPE.WEEK,
        order: 2,
    },
    [PARTNER_STATISTICS_GROUP_TYPE.MONTH]: {
        field: 'date',
        format: value => moment(value).format('MM/YYYY'),
        title: 'statistics.groups.month',
        type: PARTNER_STATISTICS_GROUP_TYPE.MONTH,
        order: 3,
    },
}

export const DEFAULT_FILTER_PARAMS = {
    campaign_name: '',
    campaign_channel: '',
    getStartDate: () => moment().startOf('month').toDate(),
    getEndDate: () => new Date(),
    group_type: PARTNER_STATISTICS_GROUP_TYPE.DAY,
}

export const formatStartDate = (dateObject) => (
    dateObject ? moment.utc(dateObject).startOf('day').toISOString() : undefined
);
export const formatEndDate = (dateObject) => (
    dateObject ? moment.utc(dateObject).endOf('day').toISOString() : undefined
);

/** Restore form dates from API filter payload stored in Redux. */
export const parseFilterStartDate = (filters) => {
    if (!filters) {
        return DEFAULT_FILTER_PARAMS.getStartDate();
    }
    return filters.start_date ? moment(filters.start_date).toDate() : null;
};

export const parseFilterEndDate = (filters) => {
    if (!filters) {
        return DEFAULT_FILTER_PARAMS.getEndDate();
    }
    return filters.end_date ? moment(filters.end_date).toDate() : null;
};

export const buildStatisticsLoadParams = ({
    groupType = DEFAULT_FILTER_PARAMS.group_type,
    startDate = DEFAULT_FILTER_PARAMS.getStartDate(),
    endDate = DEFAULT_FILTER_PARAMS.getEndDate(),
    campaignName = DEFAULT_FILTER_PARAMS.campaign_name,
    campaignChannel = DEFAULT_FILTER_PARAMS.campaign_channel,
} = {}) => ({
    group_type: groupType,
    start_date: formatStartDate(startDate),
    end_date: formatEndDate(endDate),
    campaign_name: campaignName,
    campaign_channel: campaignChannel,
});

export const getStatisticsLoadParamsFromSaved = (filters) => {
    if (!filters) {
        return buildStatisticsLoadParams();
    }
    return {
        group_type: filters.group_type || DEFAULT_FILTER_PARAMS.group_type,
        start_date: filters.start_date,
        end_date: filters.end_date,
        campaign_name: filters.campaign_name || '',
        campaign_channel: filters.campaign_channel || '',
    };
};

export const formatRegisteredAtColumn = (timestamp) => {
    if (!timestamp) {
        return '-';
    }
    return moment(timestamp).format('DD/MM/YYYY');
}
